import getItemFromStorage from './getItemFromStorage'

export default function (identifier, items) {
    const existingItems = getItemFromStorage(identifier)
    if (!existingItems) {
        setItemToStorage(identifier, items)
    } else {
        const nonMatchingKeysObject = getListWithNonMatchingValues(
            existingItems,
            items
        )

        const updatedItems = [...nonMatchingKeysObject, ...items]
        setItemToStorage(identifier, updatedItems)
    }
}

const setItemToStorage = (identifier, object) => {
    sessionStorage.setItem(identifier, JSON.stringify(object))
}

const getListWithNonMatchingValues = (existingList, newList) => {
    const nonMatchingValuesList = []

    existingList.map((item) => {
        const match = newList.find((newItem) => newItem.name === item.name)
        if (!match) {
            nonMatchingValuesList.push(item)
        }
    })
    return nonMatchingValuesList
}
